<template>
    <div class="card my-1">
        <div class="card-header text-white text-center app-class-summary-panel-headings">
            <h4><strong>COMMUNICATIONS</strong></h4>
        </div>
        <div class="card-body app-class-summary-panel-body">
            <v-simple-table>
                <template v-slot:default>
                    <tbody>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Cellphone
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_1" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Computer Email or Internet Access
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_2" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
    </div>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//GENERIC COMPONENTS
import ComponentColorCoderBool from '@/components/ComponentColorCoderBool';

//########################################
//IMPORTS components
//########################################

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentSummary3',

    props:[
        'prop_submission'
    ],

    components:{
        //GENERIC COMPONENTS
        ComponentColorCoderBool
    },

    data: function()
    {
        return {
        }
    },

    computed:{
        data_qst_1:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/AdminSysInf/AdminSys/admin14"];
        },
        data_qst_2:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/AdminSysInf/AdminSys/admin15"];
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>